import React from "react";
import { useLanguage } from "../context/LanguageContext";

const services = [
  {
    id: 1,
    title: { sq: "Ndërrim Ekrani", en: "Screen Replacement" },
    description: {
      sq: "Zëvendësim profesional i ekranit për të gjitha modelet e telefonave.",
      en: "Professional screen replacement for all phone models.",
    },
    icon: "📱",
  },
  {
    id: 2,
    title: { sq: "Riparim Bordi", en: "Board Repair" },
    description: {
      sq: "Riparim i pllakës amë për probleme të rënda teknike.",
      en: "Motherboard repair for complex hardware issues.",
    },
    icon: "🔩",
  },
  {
    id: 3,
    title: { sq: "Riparim Sensorësh", en: "Sensor Repair" },
    description: {
      sq: "Rregullim i sensorëve të telefonit me precizion të lartë.",
      en: "Fixing phone sensors with high precision.",
    },
    icon: "📊",
  },
  {
    id: 4,
    title: { sq: "Data Recovery", en: "Data Recovery" },
    description: {
      sq: "Rikuperim i të dhënave nga pajisje të dëmtuara.",
      en: "Recover lost data from damaged devices.",
    },
    icon: "💾",
  },
  {
    id: 5,
    title: { sq: "Riparim Xhamash", en: "Glass Repair" },
    description: {
      sq: "Ndërrim xhami pa ndërruar ekranin komplet.",
      en: "Glass replacement without full screen change.",
    },
    icon: "⚙️",
  },
  {
    id: 6,
    title: { sq: "Diagnostikim", en: "Diagnosis" },
    description: {
      sq: "Kontroll i plotë profesional i pajisjes.",
      en: "Full professional device diagnosis.",
    },
    icon: "🔧",
  },
  {
    id: 7,
    title: { sq: "Instalim Software", en: "Software Install" },
    description: {
      sq: "Instalim dhe përditësim sistemesh.",
      en: "System installation and updates.",
    },
    icon: "💿",
  },
  {
    id: 8,
    title: { sq: "Pastrimi Pajisjes", en: "Device Cleaning" },
    description: {
      sq: "Pastrim i brendshëm për performancë më të mirë.",
      en: "Internal cleaning for better performance.",
    },
    icon: "🧼",
  },
];

const Repair = () => {
  const { lang } = useLanguage();

  const phone = "355674909765";

  const handleWhatsApp = (service) => {
    const msg =
      lang === "en"
        ? `Hello, I am interested in: ${service.title.en}. Can you help me?`
        : `Përshëndetje, jam i interesuar për: ${service.title.sq}. A mund të më ndihmoni?`;

    window.open(
      `https://wa.me/${phone}?text=${encodeURIComponent(msg)}`,
      "_blank"
    );
  };

  return (
    <div className="max-w-7xl mx-auto py-10 px-4">

      <h1 className="text-3xl font-bold mb-8 text-center">
        {lang === "en" ? "Our Repair Services" : "Shërbimet tona të Riparimit"}
      </h1>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">

        {services.map((s) => (
          <div
            key={s.id}
            className="bg-white rounded-2xl p-6 shadow-md hover:shadow-xl transition duration-300 hover:-translate-y-1"
          >
            {/* ICON */}
            <div className="text-4xl mb-3">{s.icon}</div>

            {/* TITLE */}
            <h3 className="text-lg font-bold">
              {lang === "en" ? s.title.en : s.title.sq}
            </h3>

            {/* DESCRIPTION */}
            <p className="text-sm text-gray-500 mt-2">
              {lang === "en" ? s.description.en : s.description.sq}
            </p>

            {/* BUTTON */}
            <button
              onClick={() => handleWhatsApp(s)}
              className="mt-4 w-full bg-green-600 hover:bg-green-700 text-white text-sm py-2 rounded-lg transition"
            >
              {lang === "en" ? "Ask on WhatsApp" : "Pyet në WhatsApp"}
            </button>
          </div>
        ))}

      </div>
    </div>
  );
};

export default Repair;